export const supplierContactsListingRoutes = [
  {
    path: 'listing',
    name: 'supplier-contacts-listing',
    component: () =>
      import(/* webpackChunkName: "supplier-contacts-listing" */ './SupplierContactsListing.vue')
  }
];
